export const SERVICE_CODE = 'ACTIVITY_TYPES' + '_SERVICE';
